module.exports = __webpack_public_path__ + "aac7e2e692f29bb0a2b7adafb2bb0c0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/OTPAwardBadge.png
// module id = 2099
// module chunks = 1